import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton, FormControl, RadioGroup, Radio } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { OUR_MODULES_LIST } from '../../../Utility/Constants'
import { localSetItem } from '../../../Utility/Services/CacheProviderService'

const active_status = [{ label: "All", value: "" }, { label: "Active", value: "true" }, { label: "In Active", value: "false" }]

export default function SubLocationCreation() {
    const [departmentList, setDepartmentList] = useState([]);
    const [subLocationList, setSubLocationList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [subLocationName, setSubLocationName] = useState('');
    const [subLocationcode, setSubLocationcode] = useState('');
    const [module, setModule] = useState(null);
    const [department, setDepartment] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [EditID, setEditID] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [filterOpen, setFilterOpen] = useState(false);
    const [filterActiveStatus, setFilterActiveStatus] = useState({ label: "All", value: "" });
    const [isDelete, setisDelete] = useState(false);


    useEffect(() => {
        getSubLocationList()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }


    const getSubLocationList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.SUB_LOCATION_CREATION_MASTER + '?only_store=true')
                .then((response) => {
                    if (response.data.status === 'success') {
                        setSubLocationList(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getModuleList = () => {
        try {
            setisloader(true)
            RestAPIService.LoginAuthGetModules(Serviceurls.GET_MODULES_LIST).
                then((response) => {
                    if (response.data.status === 'success') {
                        if (response.data.data?.length > 0) {
                            var ModulesList = JSON.stringify(response.data.data);
                            localSetItem("ModulesList", ModulesList)
                        }
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const onChangeHandler = (e, name) => {
        let value = e.target.value
        switch (name) {
            case 'subLocationName':
                if (value === "" || value.length <= 50) {
                    setSubLocationName(value)
                }
                break
        }
    }

    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    value={val ? val : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const TableHeaderBtns = () => {
        return (
            <Box>
                {/* <Tooltip title="Filter" placement='top' arrow>
                    <IconButton onClick={() => { setFilterOpen(true) }}><FilterAltIcon color='primary' /></IconButton>
                </Tooltip> */}
            </Box>
        )
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText fromStore={true} isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} renderComponent={TableHeaderBtns} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = subLocationList.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        subLocationList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            // {
            //     field: 'sublocation_code', headerName: 'Sub Location Code', flex: 0.1,
            //     renderCell: (params) => (<Box component={'div'}>{params?.row?.department_code ? params?.row?.department_code : '-'}</Box>)

            // },
            {
                field: 'sublocation_name', headerName: 'Sub Location Name', flex: 0.4,
                renderCell: (params) => (params.row.sublocation_name ? params.row.sublocation_name?.length > 50 ?
                    <Tooltip placement="top" title={params.row.sublocation_name}><Typography fontSize={'0.9vw'}>{params.row.sublocation_name?.slice(0, 50) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.sublocation_name}</Typography> : '-')
            },
            {
                field: 'module', headerName: 'Module', flex: 0.4,
                renderCell: (params) => (params.row.module ? params.row.module?.length > 50 ?
                    <Tooltip placement="top" title={params.row.module}><Typography fontSize={'0.9vw'}>{params.row.module?.slice(0, 50) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.module}</Typography> : '-')
            },
            // {
            //     field: 'department_name', headerName: 'Department', flex: 0.2,
            //     renderCell: (params) => (params.row.department_name ? params.row.department_name?.length > 50 ?
            //         <Tooltip placement="top" title={params.row.department_name}><Typography fontSize={'0.9vw'}>{params.row.department_name?.slice(0, 50) + '...'}</Typography></Tooltip> :
            //         <Typography fontSize={'0.9vw'}>{params.row.department_name}</Typography> : '-')
            // },
            // {
            //     field: 'is_active', headerName: 'Status', flex: 0.2,
            //     renderCell: (params) => (<Box component={'div'}>{params?.row?.is_active ? "Active" : 'InActive'}</Box>)
            // },
            {
                field: 'action', headerName: 'Action', flex: 0.2,
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw" onClick={() => {
                                setSubLocationName(params.row.sublocation_name ? params.row.sublocation_name : "");
                                setModule(OUR_MODULES_LIST.find((item) => item.value === params.row.module) || null)
                                setIsActive(params.row.is_active)
                                setEditID(params.row.id)
                            }} />
                        </Stack>
                    </Stack>)

            },
        ]
        return (
            <Box sx={{ height: '61vh', marginTop: '.5vw' }}>
                <DataGrid
                    // checkboxSelection
                    // selectionModel={CheckBoxList}
                    // onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={subLocationList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    // page={page}
                    // pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    // onPageChange={(newPage) => { setpage(newPage) }}
                    // onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    // rowsPerPageOptions={[10, 20, 30]}
                    // pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const clearFunction = () => {
        setSubLocationName('');
        setSubLocationcode('');
        setFilterOpen(false);
        setisDelete(false);
        setIsActive(true);
        setCheckBoxList([])
        setdelIDs([])
        setEditID(null)
        setModule(null)
        setDepartment([])
    }

    const addVendorDetails = () => {
        try {
            if (!subLocationName) {
                errorMessage('Please Enter Sub Location Name')
            } else if (!module?.value) {
                errorMessage('Please Select Module')
            } else {
                let data = {
                    'id': EditID ? EditID : null,
                    'sublocation_name': subLocationName,
                    'sublocation_type': 1,
                    'module': module?.value || null,
                    'is_allow_bill': false,
                    'is_allow_discount': false,
                    'is_active': isActive,
                    'for_store': true,
                }
                RestAPIService.create(data, Serviceurls.SUB_LOCATION_CREATION_MASTER)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            successMessage(response.data.message)
                            clearFunction()
                            getSubLocationList()
                            getModuleList()
                        }
                    }).catch(e => {
                        setisloader(false)
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })
            }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const deleteVendor = () => {
        try {
            RestAPIService.delete(`${Serviceurls.STORE_DEPARTMENT}?ids=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        closeFilter();
                        clearFunction()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={active_status}
                            getOptionLabel={(option) => option?.label}
                            value={filterActiveStatus}
                            onChange={(event, newValue) => {
                                setFilterActiveStatus(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Active Status'}
                                />
                            )}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            setFilterActiveStatus({ label: "All", value: "" })
                        }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '15.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                        {/* {textBox("Sub Location Code", 'subLocationcode', subLocationcode, '15vw', true)} */}
                        {textBox("Sub Location Name *", 'subLocationName', subLocationName, '15vw')}
                        <Autocomplete
                            size='small'
                            options={OUR_MODULES_LIST}
                            getOptionLabel={(option) => option?.module_name}
                            value={module}
                            onChange={(event, newValue) => {
                                setModule(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Select Module'}
                                    sx={{ width: "15vw", marginRight: '0.3vw' }}
                                />
                            )}
                        />
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', visibility: "hidden" }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' disabled={!EditID} />} label={"Active"} />
                    </Box>
                    <Box sx={{ gap: '1vw' }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} onClick={() => { addVendorDetails() }}>{EditID ? "Update" : "Add"}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '61vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this item ?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter.bind(this)}
                    removeData={deleteVendor.bind(this)}
                />
                : null}
        </Box>
    )
}
